export default __webpack_public_path__ + "static/media/at-demo_logo.a469fce6.png";